import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  chooseYourVariant: {
    id: 'pd.shadefinder.chooseYourVariant',
    defaultMessage: 'Najděte svůj odstín',
  },
  chooseSkinShadeTitle: {
    id: 'pd.shadefinder.chooseSkinShadeTitle',
    defaultMessage: 'Vyberte odstín pleti',
  },
  chooseSkinShadeDescription: {
    id: 'pd.shadefinder.chooseSkinShadeDescription',
    defaultMessage:
      'Vyberte modelku s takovým odstínem pleti, který se nejvíc podobá tomu vašemu.',
  },
  chooseSkinUndertoneTitle: {
    id: 'pd.shadefinder.chooseSkinUndertoneTitle',
    defaultMessage: 'Teď vyberte podtón pleti',
  },
  chooseSkinUndertoneDescription: {
    id: 'pd.shadefinder.chooseSkinUndertoneDescription',
    defaultMessage:
      'Podtón je neměnný a určuje teplotu odstínu vaší pokožky, nemá na něj vliv ani aktuální opálení. Make-up se špatně zvoleným podtónem s pletí nikdy dokonale nesplyne.',
  },
  lastStepTitle: {
    id: 'pd.shadefinder.lastStepTitle',
    defaultMessage: 'Blížíme se do finále',
  },
  lastStepDescription: {
    id: 'pd.shadefinder.lastStepDescription',
    defaultMessage:
      'Vybrali jsme pro vás několik odstínů, které sednou vašemu typu i podtónu pleti.',
  },
  howWeChooseShadesButton: {
    id: 'pd.shadefinder.howWeChooseShadesButton',
    defaultMessage: 'Jak vybíráme odstíny?',
  },
  howWeChooseShadesTitle: {
    id: 'pd.shadefinder.howWeChooseShadesTitle',
    defaultMessage: 'Jak odstíny vybíráme?',
  },
  howWeChooseShadesDescription: {
    id: 'pd.shadefinder.howWeChooseShadesDescription',
    defaultMessage: 'Mravenčí práce, která za to stojí.',
  },
  howWeChooseShadesStep1Title: {
    id: 'pd.shadefinder.howWeChooseShades.step.1.title',
    defaultMessage: '1. Testování',
  },
  howWeChooseShadesStep1Description: {
    id: 'pd.shadefinder.howWeChooseShades.step.1.description',
    defaultMessage:
      'Odstíny jednotlivých make-upů ze všeho nejdřív zkoušíme na stovkách našich modelek s různými typy pleti.',
  },
  howWeChooseShadesStep2Title: {
    id: 'pd.shadefinder.howWeChooseShades.step.2.title',
    defaultMessage: '2. Analýza',
  },
  howWeChooseShadesStep2Description: {
    id: 'pd.shadefinder.howWeChooseShades.step.2.description',
    defaultMessage:
      'Naši beauty experti následně profesionálně zhodnotí jednotlivé typy odstínů a vyberou ty nejvhodnější odstíny pro každou kombinaci pleti a podtónu.',
  },
  howWeChooseShadesStep3Title: {
    id: 'pd.shadefinder.howWeChooseShades.step.3.title',
    defaultMessage: '3. Optimalizace',
  },
  howWeChooseShadesStep3Description: {
    id: 'pd.shadefinder.howWeChooseShades.step.3.description',
    defaultMessage:
      'Výběr konkrétních odstínů neustále zdokonalujeme, především díky zpětné vazbě našich zákaznic.',
  },
  iWantToChooseShade: {
    id: 'pd.shadefinder.howWeChooseShades.iWantToChooseShade',
    defaultMessage: 'Chci si vybrat odstín',
  },
  makeupTip: {
    id: 'pd.shadefinder.makeupTip',
    defaultMessage:
      '<strong>Tip!</strong> Make-up protáhněte až k dekoltu, aby líčení\n' +
      '          působilo zcela přirozeně.',
  },
  recommendedVariantTitle: {
    id: 'pd.shadefinder.recommendedVariantTitle',
    defaultMessage: 'Máme tu vítěze!',
  },
  recommendedVariantDescription: {
    id: 'pd.shadefinder.recommendedVariantDescription',
    defaultMessage:
      'Společně jsme pro vás vybrali odstín, který vaší pleti sedne nejvíc.',
  },
  selectVariantButton: {
    id: 'pd.shadefinder.selectVariantButton',
    defaultMessage: 'Tento odstín chci',
  },
  ultraBright: {
    id: 'pd.shadefinder.ultraBright',
    defaultMessage: 'Ultra světlý',
  },
  bright: {
    id: 'pd.shadefinder.bright',
    defaultMessage: 'Světlý',
  },
  medium: {
    id: 'pd.shadefinder.medium',
    defaultMessage: 'Střední',
  },
  mediumDark: {
    id: 'pd.shadefinder.dark',
    defaultMessage: 'Středně tmavý',
  },
  dark: {
    id: 'pd.shadefinder.ultraDark',
    defaultMessage: 'Tmavý',
  },
  undertoneCold: {
    id: 'pd.shadefinder.undertoneCold',
    defaultMessage: 'Studený',
  },
  undertoneColdIndicator: {
    id: 'pd.shadefinder.undertoneColdIndicator',
    defaultMessage: 'narůžovělé tóny pleti',
  },
  undertoneColdDescription: {
    id: 'pd.shadefinder.undertoneColdDescription',
    defaultMessage: 'špatně se opaluje, rychle se spálí nebo zarudne',
  },
  undertoneNeutral: {
    id: 'pd.shadefinder.undertoneNeutral',
    defaultMessage: 'Neutrální',
  },
  undertoneNeutralIndicator: {
    id: 'pd.shadefinder.undertoneNeutralIndicator',
    defaultMessage: 'nepřevažuje nádech žluté ani růžové barvy',
  },
  undertoneNeutralDescription: {
    id: 'pd.shadefinder.undertoneNeutralDescription',
    defaultMessage: 'opaluje se do přirozených, jemně hnědých tónů',
  },
  undertoneWarm: {
    id: 'pd.shadefinder.undertoneWarm',
    defaultMessage: 'Teplý',
  },
  undertoneWarmIndicator: {
    id: 'pd.shadefinder.undertoneWarmIndicator',
    defaultMessage: 'žlutá, oranžová či nazlátlá barva',
  },
  undertoneWarmDescription: {
    id: 'pd.shadefinder.undertoneWarmDescription',
    defaultMessage: 'velice snadno se opálí do bronzových tónů',
  },
  swatchLighter: {
    id: 'pd.shadefinder.swatch.lighter',
    defaultMessage: 'Světlejší',
  },
  swatchLighterDescription: {
    id: 'pd.shadefinder.swatch.lighterDescription',
    defaultMessage: 'Tento odstín je vhodné doladit bronzerem nebo tvářenkou.',
  },
  swatchIdeal: {
    id: 'pd.shadefinder.swatch.ideal',
    defaultMessage: 'Optimální',
  },
  swatchIdealDescription: {
    id: 'pd.shadefinder.swatch.idealDescription',
    defaultMessage:
      'Působí nejpřirozeněji, líčení zakončíte tvářenkou nebo rozjasňovačem.',
  },
  swatchDarker: {
    id: 'pd.shadefinder.swatch.darker',
    defaultMessage: 'Tmavší',
  },
  swatchDarkerDescription: {
    id: 'pd.shadefinder.swatch.darkerDescription',
    defaultMessage:
      'Ideální pro chvíle, kdy chcete v obličeji vypadat opálená.',
  },
  sharePopupLabel: {
    id: 'pd.shadefinder.sharePopupLabel',
    defaultMessage: 'Líbí se vám Shade Finder?',
  },
  shareButtonLabel: {
    id: 'pd.shadefinder.shareButtonLabel',
    defaultMessage: 'Sdílej',
  },
});
